import React from 'react';

export const LocationPinIcon = ({color, width, height}: any) => {
  return (
    <svg
      width={width}
      height={height}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      fill={color}
      viewBox="0 0 1000 1000"
      enable-background="new 0 0 1000 1000">
      <metadata>
        {' '}
        Svg Vector Icons : http://www.onlinewebfonts.com/icon{' '}
      </metadata>
      <g>
        <path d="M663.4,336.7c0-45.1-16-83.6-47.9-115.5c-31.9-31.9-70.4-47.9-115.5-47.9c-45.1,0-83.6,16-115.5,47.9c-31.9,31.9-47.9,70.4-47.9,115.5c0,45.1,16,83.6,47.9,115.5C416.5,484,455,500,500,500c45.1,0,83.6-16,115.5-47.9C647.4,420.2,663.4,381.7,663.4,336.7L663.4,336.7z M826.7,336.7c0,46.4-7,84.4-21.1,114.2L573.4,944.7c-6.8,14-16.9,25.1-30.3,33.2c-13.4,8.1-27.8,12.1-43.1,12.1c-15.3,0-29.7-4-43.1-12.1s-23.3-19.2-29.7-33.2L194.4,450.9c-14-29.8-21.1-67.9-21.1-114.2c0-90.2,31.9-167.2,95.7-231C332.8,41.9,409.8,10,500,10c90.2,0,167.1,31.9,231,95.7C794.7,169.5,826.6,246.5,826.7,336.7L826.7,336.7z" />
      </g>
    </svg>
  );
};
